var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('div',{staticClass:"about"},[_c('PartnerBannersView',{attrs:{"id":"partnership","timestamp":_vm.timestamp}}),_c('SectionWhyPartnership'),_c('SectionOurPartner',{attrs:{"id":"ourpartner"}}),_c('SectionClientVoice'),_c('SectionBecomePartner')],1)
}
var staticRenderFns = []

export { render, staticRenderFns }